import images from '../assets/images';

const getImageFromAssets = (name) => images[name];
export default getImageFromAssets;